import store from "../../context/store/store";
import { Types } from '../../context/action/action';
import _ from "lodash";

export const storeWindowState = (currentWindowState:string,history?:any) => {
  let pathName = window.location.pathname;
  let{currenthomeState}=store.getState().meetingReducer;
  if(pathName === '/home' && history !== undefined){
    history.push('/meeting')
    storeHOMEWindowState('home')
  }
  store.dispatch({
    type: Types.MEETING_WINDOW_STATE,
    payload: {
      currentWindowState: currenthomeState==='home'? "createMeeting": currentWindowState
    }
  });
  if(currenthomeState==='home'){
    storeHOMEWindowState('')
  }
};
export const storeHOMEWindowState = (currenthomeState:string) => {
  store.dispatch({
    type: Types.MEETING_HOME_STATE,
    payload: {
      currenthomeState:currenthomeState
    }
  });
}

export const setSearchKey=(data:any)=>{
  store.dispatch({
    type: Types.CC,
    payload: {
      searchKey:data
    }
  });
}


export const storeMOM=(overall:any,part:any,key:any,highlights:any,load:any)=>{
  store.dispatch({
    type: Types.MOM_PAGE,
    payload: {
      originalMOM:overall,
      momLoad:load,
      part_MOM:part,
      keywords:key
    }
  });

  store.dispatch({
    type: Types.HIGHLIGHT_PAGE,
    payload: {
      meetingHighlights:highlights
    }
  });
}

export const storeEditMOMCopy=(data:any,editstate:any)=>{
  console.log("dataa",data);
  
  let{editMOM,meetingHighlights}=store.getState().meetingReducer;
  store.dispatch({
    type: Types.EDIT_MOM,
    payload: {
      editMOM:editMOM,
      editMOMCopy:data,
      editSummaryState:editstate
      
    }
  })
  store.dispatch({
    type: Types.HIGHLIGHT_PAGE,
    payload: {
      meetingHighlights:meetingHighlights
    }
  });
}

export const storeEditMOM=(data:any,editstate:boolean)=>{
  
  let{editMOMCopy,meetingHighlights}=store.getState().meetingReducer;
  store.dispatch({
    type: Types.EDIT_MOM,
    payload: {
      editMOM:data,
      editMOMCopy:editMOMCopy,
      editSummaryState:editstate
    }
  });
  store.dispatch({
    type: Types.HIGHLIGHT_PAGE,
    payload: {
      meetingHighlights:meetingHighlights
    }
  });
}

export const storeTranscript=(data:any,load:boolean,count:number)=>{
  store.dispatch({
    type: Types.TRANSCRIPT_PAGE,
    payload: {
      transcript:data,
      transcriptLoad:load,
      transcriptCount:count
    }
  });
}
export const storeActions=(data:any,load:boolean,count:number)=>{
const oldKey_action = "text";//crash check
const newKey_action = "actions";
const oldKey_name = "participant_name";//crash check
const newKey_name = "name";

data?.forEach((item:any) => {

    if (item?.hasOwnProperty(oldKey_action)) {
        item[newKey_action] = item[oldKey_action];
        delete item[oldKey_action];
    }
    if (item?.hasOwnProperty(oldKey_name)) {
      item[newKey_name] = item[oldKey_name];
      delete item[oldKey_name];
  }
});

  store.dispatch({
    type: Types.ACTIONS_PAGE,
    payload: {
      actionsData:data,
      actionsLoad:load,
      actionsCount:count
    }
  });
}

export const storePerformance=(data:any,load:boolean,count:number)=>{
  store.dispatch({
    type: Types.PERFORMANCE_PAGE,
    payload: {
      performanceData:data,
      performanceLoad:load,
      performanceCount:count
    }
  });
}


export const ccTabChange=(key:any)=>{
  console.log(key,"keyy");
  
  store.dispatch({
    type: Types.CC_TAB,
    payload: { ccTab: key }
  });
}

export const storeMeetingList = (list: Array<object>) => {
  store.dispatch({
    type: Types.MEETING_LEFT_SIDE,
    payload: { meetingList: list }
  });
};

export const getvideoRecording = (list: any,count:any,loader:boolean) => {

  store.dispatch({
    type: Types.VIDEO_RECORDING_LIST,
    payload: { videoRecordingList: list,recCount:count,recLoad:loader }
  });
};

export const storeVideoRecordingList = (data: any) => {
  store.dispatch({
    type: Types.STORE_VIDEORECORDING_LIST_INPUT,
    payload: {
      getRecordListInput: {
        offset:data.offset,
        limit:data.limit,
        search:data.search
    }}
  });
};

export const storeGetMeetingByDate = (list: Array<object>, date?:any) => {
  store.dispatch({
    type: Types.MEETING_CALENDAR_LIST,
    payload: { meetingListByDate: list, filterDate: date}
  });
};

export const storeMeetingListInput = (data: any) => {
  store.dispatch({
    type: Types.STORE_MEETING_LIST_INPUT,
    payload: {
      getListInput: {
        offset:data.offset,
        limit:data.limit,
        filter:data.filter,
        searchText:data.searchText,
        sort:data.sort
    }}
  });
};

export const storeTemplateList = (data:any) => {
    store.dispatch({
    type: Types.TEMPLATE_LIST,
    payload: data
  });
}

export const storeTemplateListInput = (data: any) => {
  store.dispatch({
    type: Types.STORE_TEMPLATE_LIST_INPUT,
    payload: {
      getTemplateListInput: {
        offset: data.offset,
        limit: data.limit,
        sort: data.sort,
        sortType:data.sortType
    } }
  });
};

export const storeSortTemplateList = (data:any) => {
   store.dispatch({
    type: Types.STORE_SORT_TEMPLATE_LIST_INPUT,
     payload: data
  });
}

export const leftBarLoader = (isLoad:Boolean) => {
  store.dispatch({
    type: Types.LEFT_SIDE_LOADER,
    payload: { isLeftBarLoading: isLoad }
  });
};
export const storeMeetingPage = (detail:object) => {
  store.dispatch({
    type: Types.MEETING_DETAIL_PAGE,
    payload: { detailPage: detail }
  });
};
export const storePlayListPage = (detail:object) => {
  console.log("storePlayListPage")
  store.dispatch({
    type: Types.PLAY_LIST_PAGE,
    payload: { playListsPage: detail.data }
  });
};
export const storeTemplate = (detail:object) => {
  store.dispatch({
    type: Types.TEMPLATE_DETAIL_PAGE,
    payload: detail
  });
};

export const storeCurrentMeetingDetail = (currentDetails:object) => {
  store.dispatch({
    type: Types.MEETING_DETAIL_CURRENT_PAGE,
    payload: currentDetails
  });
};
export const savedTemplateLoader = (templateLoader:boolean) => {
  store.dispatch({
    type: Types.SAVED_TEMPLATE_LOADER,
    payload: { templateListLoader: templateLoader }
  });
};
export const storePreviousMeetingDetail = (currentDetails:object) => {
  store.dispatch({
    type: Types.MEETING_DETAIL_PREVIOUS_PAGE,
    payload: currentDetails
  });
};

export const storeMeetingTotalCountList = (data:any) => {
  store.dispatch({
  type: Types.MEETING_TOTAL_COUNT,
  payload: data
});
    store.dispatch({
      type: Types.VIDEOMEET_COUNT_STATUS,
      payload: {
        meetingCountStatus:false
      }
    })
}